import React from 'react';

import Intro from './S01_Intro';
import People from './S02_People';
import Video from './S03_Video';
import Categories from './S04_Categories';

const Home = () => {
  return (
    <>
      <Intro />
      <People />
      <Video />
      <Categories />
    </>
  );
};

export default Home;
